// src/pages/OnboardingPlanPage.js
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Onboarding from "../components/Onboarding";

function skipKeyFor(user) {
  const id = user?.id || user?.email || "anon";
  return `plan_onboarding_skipped_v1:${id}`;
}

export default function OnboardingPlanPage({ user, onLogout }) {
  const nav = useNavigate();

  // If user entered plan creation, ensure "skipped" flag is cleared
  useEffect(() => {
    try {
      if (user) localStorage.removeItem(skipKeyFor(user));
    } catch {}
  }, [user]);

  return (
    <>
      {/* Onboarding already has its own full-height layout */}
      <Onboarding
        planOnly
        onComplete={() => nav("/plan", { replace: true })}
        onSkip={() => nav("/plan", { replace: true })}
      />
    </>
  );
}